import $ from "jquery";

const menu = $('.m-menu'),
    menuModel=$('.menu-model'),
    menuClose=$('.m-close');

menu.on("click",function () {
  menuModel.removeClass('open').addClass('open')
});
menuClose.on("click",function () {
  menuModel.removeClass('open');
});